import { css } from '@emotion/react'
import { Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useState } from 'react'
import { LiveEventRace } from 'services/api/database/EventService'
import { unifiedColors } from 'styles/colors'
import { styled } from 'styles/styled'
import { GpxMap } from './GpxMap'
import { MapContainerDiv } from './MapContainer.style'

const RaceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 19px 0;
`

const RaceName = styled.div<{ $isActive: boolean }>`
  border-radius: 40px;
  background-color: transparent;
  color: ${unifiedColors.label.subdued};
  font-weight: 600;
  ${({ $isActive }) =>
    $isActive &&
    css`
      background-color: ${unifiedColors.button.tertiary.default};
      color: ${unifiedColors.label.onPurple};
      font-weight: bold;
    `}
  padding: 12px 16px;
  cursor: pointer;
`

interface Props {
  races: LiveEventRace[]
}

export const MapContainer = ({ races }: Props) => {
  const filterRace = races.filter(
    (race) => race.raceInfo && race.raceInfo.gpxFileUrl
  )
  const [activeRace, setActiveRace] = useState<LiveEventRace | undefined>(
    filterRace[0]
  )
  const { t } = useTranslation('event')

  return (
    <MapContainerDiv>
      <Typography variant="h4">{t('parcours')}</Typography>
      <RaceContainer>
        {filterRace.map((race) => (
          <RaceName
            key={race.id}
            $isActive={race.id === activeRace?.id}
            onClick={() => setActiveRace(race)}
          >
            {race.name}
          </RaceName>
        ))}
      </RaceContainer>
      {activeRace?.raceInfo?.gpxFileUrl && (
        <GpxMap gpxUrl={activeRace.raceInfo.gpxFileUrl} />
      )}
    </MapContainerDiv>
  )
}
